<template>
  <div>
    <a-form class="simiot-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="8" :xxl="6">
          <a-form-item label="流量场景">
            <a-select
              v-decorator="['traffic_scene_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingSceneOptions"
            >
              <a-select-option
                v-for="opt in sceneOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="卡板材质">
            <a-select
              v-decorator="['card_type_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingCardTypeOptions"
              @change="handleCardTypeChange"
            >
              <a-select-option
                v-for="opt in cardTypeOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="卡片尺寸">
            <a-select
              v-decorator="['card_shape_name']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请先选择卡板材质"
              :loading="loadingCardShapeOptions"
            >
              <a-select-option
                v-for="opt in cardShapeOptions"
                :key="opt.name || opt"
                :value="opt.name || opt"
              >
                {{ opt.name || opt }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="服务周期">
            <a-select
              v-decorator="['service_cycle']"
              allow-clear
              placeholder="请选择"
            >
              <a-select-option :value="0">
                无（非小流量）
              </a-select-option>
              <a-select-option
                v-for="opt in serviceCycleOptions"
                :key="opt.value"
                :value="opt.value"
              >
                {{ opt.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item :wrapper-col="{ span: 24 }">
            <a-button type="primary" html-type="submit">搜索</a-button>
            <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { findTrafficSceneOptions } from '@/api/traffic_scene'
import { findCardTypeOptions, findCardShapeOptions } from '@/api/common_options'
import { findBaseCarrierProductServiceCycleOptions } from '@/api/base_carrier_product'

export default {
  name: 'SearchSimCardInventoryStatistic',
  props: {
    carrierType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      sceneOptions: [],
      cardTypeOptions: [],
      cardShapeOptions: [],
      serviceCycleOptions: findBaseCarrierProductServiceCycleOptions(),
      loadingSceneOptions: false,
      loadingCardTypeOptions: false,
      loadingCardShapeOptions: false
    }
  },
  created() {
    this.fetchSceneOptions()
    this.fetchCardTypeOptions()
  },
  watch: {
    carrierType() {
      this.form.resetFields(['traffic_scene_id'])
      this.fetchSceneOptions()
    }
  },
  methods: {
    fetchSceneOptions() {
      this.loadingSceneOptions = true
      findTrafficSceneOptions({ carrier_type: this.carrierType }).then((res) => {
        if (res.code === 0) {
          this.sceneOptions = res.data || []
        }
        this.loadingSceneOptions = false
      })
    },

    fetchCardTypeOptions() {
      this.loadingCardTypeOptions = true
      findCardTypeOptions().then((res) => {
        if (res.code === 0) {
          this.cardTypeOptions = res.data || []
        }
        this.loadingCardTypeOptions = false
      })
    },

    fetchCardShapeOptions(cardTypeId) {
      this.cardShapeOptions = []
      if (!cardTypeId) {
        return
      }
      this.loadingCardShapeOptions = true
      findCardShapeOptions(cardTypeId).then((res) => {
        if (res.code === 0) {
          this.cardShapeOptions = res.data || []
        }
        this.loadingCardShapeOptions = false
      })
    },

    handleCardTypeChange(cardTypeId) {
      this.form.setFieldsValue({ card_shape_name: undefined })
      this.fetchCardShapeOptions(cardTypeId)
    },

    handleSearch(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$emit('submit', values)
        }
      })
    },

    handleReset() {
      this.form.resetFields()
      this.cardShapeOptions = []
      this.$emit('submit', {})
    }
  }
}
</script>
